import React, { useId } from 'react'
import PropTypes from 'prop-types'

const DownloadIcon = React.forwardRef(function DownloadIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1.55228 12 2 12.4477 2 13V16C2 18.7477 4.25229 21 7 21H17C19.7477 21 22 18.7477 22 16V13C22 12.4477 22.4477 12 23 12C23.5523 12 24 12.4477 24 13V16C24 19.8523 20.8523 23 17 23H7C3.14772 23 0 19.8523 0 16V13C0 12.4477 0.447715 12 1 12Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.2 9.4C7.53137 8.95817 8.15817 8.86863 8.6 9.2L12 11.75L15.4 9.2C15.8418 8.86863 16.4686 8.95817 16.8 9.4C17.1314 9.84183 17.0418 10.4686 16.6 10.8L12 14.25L7.4 10.8C6.95817 10.4686 6.86863 9.84183 7.2 9.4Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C12.5523 1 13 1.44772 13 2V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V2C11 1.44772 11.4477 1 12 1Z"
      ></path>
    </svg>
  )
})

DownloadIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

DownloadIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default DownloadIcon
